<template>
  <div class="feedback-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/07/fankui_icon.png"
           alt="">
      用户反馈
    </div>
    <el-form ref="form"
             :model="form"
             class="feedback_search"
             :inline="true">
      <el-form-item label="角色类型">
        <el-select v-model="form.appname"
                   size="small">
          <el-option label="货主公司"
                     value="0"></el-option>
          <el-option label="物流公司"
                     value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.status"
                   size="small">
          <el-option label="未处理"
                     value="0"></el-option>
          <el-option label="已处理"
                     value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btn_box">
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchClick">查看</el-button>
      </el-form-item>
    </el-form>
    <div class="feedback_table">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label="序号"
                         align="center"
                         type="index"
                         width="50">
        </el-table-column>
        <el-table-column prop="content"
                         header-align="center"
                         align="center"
                         label="反馈内容"
                         min-width="130">
        </el-table-column>
        <el-table-column prop="conpanyName"
                         label="公司名称"
                         header-align="center"
                         align="center"
                         min-width="70">
        </el-table-column>
        <el-table-column label="角色类型"
                         header-align="center"
                         align="center"
                         min-width="94">
          <template slot-scope="scope">
            <div v-if="scope.row.userType === '0'">货主公司</div>
            <div v-if="scope.row.userType === '1'">物流公司</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime"
                         label="反馈时间"
                         header-align="center"
                         align="center"
                         min-width="94">
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         min-width="94">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0"
                 class="status">未处理</div>
            <div v-if="scope.row.status === 1">已处理</div>
          </template>
        </el-table-column>

        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item checkin"
                        effect="dark"
                        content="已解决"
                        placement="top"
                        v-if="scope.row.status === 0">
              <el-button @click="handleSolveClick(scope.row.id)"></el-button>
            </el-tooltip>

            <el-tooltip class="item showimg"
                        effect="dark"
                        content="图片"
                        placement="top">
              <el-button @click="handleImgClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="showDetails"
               class="imgTable">
      <!-- <div class="imgMain"
           v-if="img">
        <img :src='img'
             alt="">
      </div>
      <div class="imgContent"
           v-if="!img">
        暂无数据
      </div> -->
      <el-carousel trigger="click"
                   arrow="always"
                   indicator-position='none'
                   :autoplay="false">
        <el-carousel-item v-for="(item,index) in imgList"
                          :key="index">
          <div class="imgMain">
            <img :src=item
                 alt="">
          </div>
          <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="solveDetail"
               width="30%">
      <span>用户反馈问题是否已解决？</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="solveDetail = false"
                   size="small">取 消</el-button>
        <el-button type="primary"
                   @click="handleClose"
                   size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { feedback, searchFeedback, solveFeedback, deleteFeedback, getFeedbackImg } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      form: {
        appname: '',
        status: ''
      },
      data: [],
      showDetails: false,
      imgList: [],
      solveDetail: false,
      solveId: ''
    }
  },
  mounted () {
    this.getFeedback()
  },
  methods: {
    getFeedback () { // 初始化获取信息
      feedback().then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    },
    handleImgClick (id) { // img图片
      this.imgList = []
      getFeedbackImg({
        id: id
      }).then(res => {
        if (res.data.code === 200) {
          this.showDetails = true
          this.imgList = res.data.data.split(',')
        } else {
          this.$alert('暂无图片', {
            confirmButtonText: '确定'
          })
        }
      })
      // this.img = this.data.result.imageUrl
      // console.log(this.data.result)
      // console.log(this.data.result.imageUrl)
      // this.data.result.forEach(element => {
      //   console.log(element)
      // })
      // for (var i = 0; i < this.data.result.length; i++) {
      //   if (id === this.data.result[i].id && this.data.result[i].imageUrl) {
      //     this.img = this.data.result[i].imageUrl
      //     this.showDetails = true
      //   }
      // }
    },
    handleCurrentChange (val) { // 页面切换
      if (this.form.status !== '' | this.form.appname !== '') {
        searchFeedback({
          userType: this.form.appname,
          status: this.form.status,
          pageNum: val
        }).then(res => {
          if (res.data.code === 200) {
            this.data = res.data.data
          }
        })
      } else {
        feedback({
          pageNum: val
        }).then(res => {
          this.data = res.data.data
        })
      }
    },
    handleSearchClick () { // 查询
      searchFeedback({
        userType: this.form.appname,
        status: this.form.status
      }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    },
    handleSolveClick (id) { // 已解决按钮
      this.solveDetail = true
      this.solveId = id
    },
    handleClose () { // 确定是否已解决
      solveFeedback({
        id: this.solveId
      }).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.data.result.length; i++) {
            if (this.solveId === this.data.result[i].id) {
              this.data.result[i].status = 1
            }
          }
          this.solveDetail = false
          this.solveId = ''
        }
      })
    },
    handleDeleteClick (id) { // 删除用户反馈
      deleteFeedback({
        id: id
      }).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.data.result.length; i++) { // 从当前列别表中删除该数据
            if (this.data.result[i].id === id) {
              this.data.result.splice(i, 1)
              this.data.total -= 1
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.feedback-container
  padding 20px
  height 100%
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    background #fff
    .title_img
      margin 0 8px 0 14px
  .feedback_search
    width calc(100% - 40px)
    padding 0 20px
    position relative
    background #fff
    .el-form-item
      margin-bottom 5px
    .btn_box
      width 80px
      float right
      position absolute
      top 0
      right 0
      .search_btn
        searchBtn()
        margin-left 0
  .feedback_table
    height calc(100% - 170px)
  .el-table
    background #f7f9fb
    .cell
      size12()
      .el-button
        padding 6px 14px
        width 28px
        cursor pointer
        height 28px
        margin 0 8px
        float right
        &.showimg
          showimg()
        &.checkin
          checkin()
        &.delete
          delete()
      .status
        color #1B88EE
  .el-table th
    background #e7f0f8
    .cell
      height 25px
      line-height 25px
  .imgTable
    .el-dialog
      background transparent
      // background #0f0
      box-shadow none
      border none
      height 100%
      margin-top 0 !important
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      .el-dialog__header
        display none
        height 42px
        padding 0 20px 0
        background #1b88ee
        .el-dialog__title
          line-height 42px
          font-size 13px
          color #fff
          float left
        .el-dialog__headerbtn
          top 12px
          right 12px
          .el-dialog__close
            color #fff
            font-size 20px
    .el-dialog__body
      padding 15px 20px
      height 100%
      // background #f66
      .el-carousel
        height 100%
      .el-carousel__container
        height 100%
      .imgMain
        width 348px
        height 100%
        margin 0 auto
        position relative
        img
          width 100%
          // height 100%
          position absolute
          top 50%
          left 50%
          transform translate(-50%, -50%)
      .imgContent
        text-align center
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
